import type { BodyRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type EventInviteesPathRequestParams = paths['/v3/event_users/{id}']['patch']['parameters']['path'];
type ResponseType = paths['/v3/event_users/{id}']['patch']['responses']['200']['content']['application/json'];
type UpdateEventRequestBody = paths['/v3/event_users/{id}']['patch']['requestBody']['content']['application/json'];

export const manageEventInvitee = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<UpdateEventRequestBody, EventInviteesPathRequestParams>) =>
  apiClient.patch<ResponseType, ApiClientResponse<ResponseType>>(routes.events.users(id), body);
